import BuildContext from "./buildContext.js"

export default class Model {
    constructor(model, context)
    {
        let bctx = new BuildContext(context)
        // every field that is localized will be transformed to normal string field instead of object
        let keys = Object.keys(model || {})
        keys.forEach(k => {
            if (this.isFieldLocalized(model[k])) {
                model[k] = model[k].locales[bctx.getLocale()]
            }
        })

        Object.assign(this, model)
    }

    getRefObj(prop) {
        let ref = this[prop + "_RefObj"];
        return ref ? ref : {}
    }

    isFieldLocalized(f) {
        if (!f) return false
        
        return f.locales !== undefined
    }

    getValues() {
        let values = {}
        
        Object.entries(this).forEach((v, k) => {
            values[k] = v
        })

        return values; 
    }
}